import { resolveAuthToken } from './utils/auth-utils';
import type { ConsentPolicy } from './types';

export const init = () => {
  const defaultPolicyJson = decodeURIComponent(
    document.getElementById('site-consent-policy')?.dataset
      .defaultConsentPolicy ?? '',
  );

  let defaultPolicy: ConsentPolicy | undefined;

  try {
    defaultPolicy = defaultPolicyJson
      ? JSON.parse(defaultPolicyJson)
      : undefined;
  } catch (e) {
    console.log(
      '[site-consent-policy] failed to parse the default consent policy',
      defaultPolicyJson,
    );
  }

  if (!window.consentPolicyManager) {
    console.log(
      '[site-consent-policy] consentPolicyManager is not defined',
      window.consentPolicyManager,
    );
  } else {
    window.consentPolicyManager?.init(
      {
        consentPolicy: defaultPolicy,
        baseUrl: document.location.origin,
      },
      () => resolveAuthToken(),
    );
  }
};
